import { useContext, useEffect } from 'react'
import { useRouter } from 'next/router'
import pclnExperimentation from '@pcln/experimentation'
import { APP_ROUTES, LOCATION_SEARCH_TYPE } from '../../types'
import ExperimentContext from '../../context/ExperimentContext'

export default function useTypeAheadExperimentForDisplayName() {
  const { AIR_HOME_UPDATED_OD_DISPLAY = 'DEFAULT' } = useContext(
    ExperimentContext
  )
  const { pathname } = useRouter()
  const isFlightRoute = pathname === APP_ROUTES.flights
  const isDisplayNameExperimentEnabled =
    isFlightRoute && AIR_HOME_UPDATED_OD_DISPLAY !== 'DEFAULT'
  const itemDisplayNameTransform = (
    item: LOCATION_SEARCH_TYPE | Record<string, never> | null
  ) => {
    if (item === null) {
      return
    }

    if (isDisplayNameExperimentEnabled && item.type === 'AIRPORT') {
      const displayNameSegments = [
        item.cityName,
        ...((item.countryCode === 'US' || item.countryCode === 'CA') &&
        item.stateCode
          ? [item.stateCode]
          : []),
        ...(item.countryCode !== 'US' ? [item.country] : [])
      ]
      return `${displayNameSegments.join(', ')} (${item.id})`
    }
    return item.itemName
  }

  useEffect(() => {
    if (isFlightRoute) {
      pclnExperimentation.fireImpression('AIR_HOME_UPDATED_OD_DISPLAY')
    }
  }, [isFlightRoute])

  return isDisplayNameExperimentEnabled ? itemDisplayNameTransform : null
}
